import React from 'react';

export default function Planos() {
  return(
    <h2>Planos</h2>
  ) 
}
